export const SV: Record<string, string> = {
  "Recommended for you": "Rekommenderat för dig",
  "Resource added to favorite": "Resurs tillagd till favoriter",
  "Failed to add resource to favorite": "Det gick inte att lägga till resurs till favoriter",
  "Resource removed from favorite": "Resurs borttagen från favoriter",
  "Failed to remove resource from favorite": "Det gick inte att ta bort resurs från favoriter",
  "Calendar": "Kalender",
  "View Detail": "Visa detaljer",
  "Add to favorites": "Lägg till i favoriter",
  "Remove from favorites": "Ta bort från favoriter",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Beskrivning: VIP-mötesrum med fantastisk utsikt och bekväma stolar.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Det finns inga tillgängliga resurser vid den valda tiden på din plats eller i dina favoriter.",
  "You have these options:": "Du har dessa alternativ:",
  "Change the meeting time.": "Ändra mötestiden.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Använd knappen <1>Hitta ledig tid</1> för att välja en ny tid.",
  "Open the search to find other resources.": "Öppna sökningen för att hitta andra resurser.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Resurstypen <1>'{{resourceType}}'</1> finns inte på din standardplats",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Resurstypen <1>'{{resourceType}}'</1> kan hittas på en annan plats.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Klicka här</1> för att lägga till resurstypen till dina standardplatsinställningar.",
  
  // ResourceCard
  "New Order": "Ny beställning",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Vid bokning av en Pooled Resource kan endast denna resurstyp och endast en resurs bokas.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Du kan inte välja både en underresurs och dess virtuella resurs samtidigt.",
  // Settings
  "Note:": "Obs:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "En assisterande organisatör kan ta emot samma e-postmeddelanden från Resource Central som organisatören och kan hantera beställningar på organisatörens vägnar.",
  "Setting updated successfully": "Inställning uppdaterad",
  "Setting updated failed": "Uppdatering av inställning misslyckades",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 plats",
  "Opening hours:": "Öppettider:",
  "Buffer time {{minutes}} mins between reservations": "Buffertid {{minutes}} min mellan bokningar",
  "Initial payment {{value}} pr.minute": "Initial betalning {{value}} per minut",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Totalt {{total}} deltagare",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} av {{total}} interna kan delta.",
  "{{external}} external is unknown.": "{{external}} externa är okända.",
  "Find available time": "Hitta ledig tid",
  "Attendees": "Deltagare",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Klicka på Mer information för att besöka vår supportsida",
  "Further information": "Mer information",
  
  // LocationSetting
  "Location changed": "Plats ändrad",
  "Location change failed": "Ändring av plats misslyckades",
  "Please select at least one location": "Välj minst en plats",
  "Resource types": "Resurstyper",
  "Location": "Plats",
  "Where": "Var",
  
  // ModalShowAttendees
  "Total": "Totalt",
  "Available": "Tillgänglig",
  "Busy": "Upptagen",
  "External": "Extern",
  "Internal": "Intern",
  
  // ResourceSearch
  "Search by resource name": "Sök efter resursnamn",
  "Category": "Kategori",
  "Filter by Location": "Filtrera efter plats",
  "Filter by Category": "Filtrera efter kategori",
  "Capacity": "Kapacitet",
  "Filter by Capacity": "Filtrera efter kapacitet",
  "All": "Alla",
  "Filter by availability": "Filtrera efter tillgänglighet",
  "Sort By": "Sortera efter",
  "Loading...": "Laddar...",
  
  // SelectedResources
  "Meeting Type": "Mötestyp",
  "Meeting Label": "Mötesetikett",
  
  // Alert (accessibility text)
  "Check icon": "Bockikon",
  "Close": "Stäng",
  
  // AppConstants - searchTab
  "Resource": "Resurs",
  "Person": "Person",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Var brukar dina möten äga rum?",
  "To improve our recommendations for you we would like you to enter your normal location": "För att förbättra våra rekommendationer för dig skulle vi vilja att du anger din vanliga plats",
  "What do you use most?": "Vad använder du mest?",
  "To enable quicker and better search please chose you prefered resource type": "För att möjliggöra snabbare och bättre sökning, vänligen välj din föredragna resurstyp",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Klicka på resursen för att välja",
  "Selected Resources": "Valda resurser",
  "Setting": "Inställning",
  "Search": "Sök",
  "Find Colleague": "Hitta kollega",
  "Quick button setting": "Snabbknappsinställning",
  "Favorite": "Favorit",
  "Most Used": "Mest använda",
  "Colleagues": "Kollegor",
  "Resources": "Resurser",
  
  // AppConstants - tooltipText
  "Back": "Tillbaka",
  "Floor Plan": "Planlösning",
  "Expand": "Expandera",
  "Selected resources": "Valda resurser",
  "View details": "Visa detaljer",
  "Remove from My Favorites": "Ta bort från mina favoriter",
  "Add to My Favorites": "Lägg till i mina favoriter",
  "Remove": "Ta bort",
  "Favorite - Most Used": "Favorit - Mest använda",
  "Conflict": "Konflikt",
  "Approved": "Godkänd",
  "Recommendeded for you": "Rekommenderat för dig",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Endast primär organisatör",
  "Only assistant organizer": "Endast assisterande organisatör",
  "Primary AND assistant organizer": "Primär OCH assisterande organisatör",
  
  // FindColleague
  "Enter colleague name": "Ange kollegans namn",
  "Recent work items": "Senaste arbetsobjekt",
  "No data available": "Inga data tillgängliga",
  "Floorplan": "Planlösning",
  "List nearby resources": "Lista över resurser i närheten",
  "Find resource nearby": "Hitta resurs i närheten",
  "No Resources available": "Inga resurser tillgängliga",
  
  // Start page
  "Next": "Nästa",
  "Failed to update default locations": "Det gick inte att uppdatera standardplatser",
  "Resource Type": "Resurstyp",
  
  // QuickSetting
  "Quick buttons updated successfully": "Snabbknappar uppdaterade",
  "Quick buttons updated failed": "Uppdatering av snabbknappar misslyckades",
  "Add more": "Lägg till mer",
  "Apply": "Tillämpa",
  "Delete": "Radera",
  "Name": "Namn",
  "Enter name": "Ange namn",
  "Tooltip": "Verktygstips",
  "Enter tooltip": "Ange verktygstips",
  "Type": "Typ",
  "Select type": "Välj typ",
  "Locations": "Platser",
  "Select colleagues": "Välj kollegor",
  "Select resources": "Välj resurser",
  
  // DefaultResourceSetting
  "Resource type changed": "Resurstyp ändrad",
  "Resource type change failed": "Ändring av resurstyp misslyckades",
  "Default Resource Type": "Standard resurstyp",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Tillämpad framgångsrikt",
  "Apply Failed": "Tillämpning misslyckades",
  "Assistant Organizer": "Assisterande organisatör",
  "Enter a part of the name to search for": "Ange en del av namnet för att söka",
  "Mail Flow": "E-postflöde",
  "Select Mail Flow": "Välj e-postflöde",
  
  // TileConfigurationSetting
  "Update settings successfully": "Inställningar uppdaterade",
  "Update settings failed": "Uppdatering av inställningar misslyckades",
  "Timeline": "Tidslinje",
  
  // SelectCategoryForm
  "And": "Och",
  "Or": "Eller",
  
  // Other
  "Resource Calendar": "Resurskalender",
  
  // SettingLabels
  "Default Location": "Standardplats",
  "Quick button": "Snabbknapp",
  "Category icons": "Kategoriikoner",
  "Recommendation screen": "Rekommendationsskärm",
  "Capacity filter": "Kapacitetsfilter",
  "AI Assistant": "AI-assistent",
  "Tile configuration": "Panelkonfiguration",
  "Help": "Hjälp",
  "Default Categories": "Standardkategorier",
  
  // MeetingType
  "Your must select a Meeting label": "Du måste välja en mötesetikett",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Vald resurs: 'AOD_Copanhagen' Motstridiga förekomster",
  "Alternative Resource": "Alternativ resurs",
  "OK": "OK",
  "Cancel": "Avbryt",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Din valda resurs 'AOD_Copenhagen' togs bort",
  "You can't book this resource as your request exceeds the available capacity.": "Du kan inte boka denna resurs eftersom din förfrågan överstiger tillgänglig kapacitet.",
  
  // ChangeTime
  "Time changed successfully": "Tid ändrad framgångsrikt",
  "Current Time": "Aktuell tid",
  "Suggested Times": "Föreslagna tider",
  "Change Time": "Ändra tid",
  "people are free": "personer är lediga",
};

